export default __webpack_public_path__ + "static/media/cert-finance-cpttm-sc.b71ffba2.jpg";